import React from 'react';
import { Contract } from '../../../types/contract.type';
import { ContractMilestone } from '../../../types/contractMilestone.type';
import { MilestoneDraft } from './modals/MilestoneEditorModal';
import MilestonesList from './MilestonesList';

export default function MilestoneTable({
    contract,
    items,
    onCreate,
    onUpdate,
    onDelete,
    canEdit,
}: {
    contract: Contract;
    items: ContractMilestone[];
    onCreate: (draft: MilestoneDraft) => void;
    onUpdate: (id: string, patch: MilestoneDraft) => void;
    onDelete: (id: string) => void;
    canEdit?: boolean;
}) {
    return (
        <MilestonesList
            contract={contract}
            items={items}
            onCreate={onCreate}
            onUpdate={onUpdate}
            onDelete={onDelete}
            canEdit={canEdit}
        />
    );
}
